import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CmsContent } from 'containers/CmsPage/CmsContent';
import { DefineVariables } from 'providers/ContextVariables';
import { decorateWith, withName } from 'helpers/decorator';
import { formatPrice, generateOfferContextVariables } from 'helpers/promotions';
import { selectPagePromotion } from 'redux/modules/page';
import { selectActivePromotion } from 'redux/saga/helpers/promotions';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
import { LS_OFFER_BANNER_KEY } from 'constants/promotions';
import { isEmpty } from 'helpers/verify';
import { deepExtract } from 'helpers/deep';

export const CmsOfferUnwrapped = ({ cmsContentSlugs, currency, intl, offer }) =>
  !isEmpty(offer) && (
    <div className="CmsOffer">
      <DefineVariables
        variables={generateOfferContextVariables({
          offer,
          initialPrice: formatPrice({
            intl,
            currency,
            price: offer.price,
          }),
          recurringPrice: formatPrice({
            intl,
            currency,
            price: offer.recurring_plan && offer.recurring_plan.price,
          }),
        })}>
        <CmsContent slugs={cmsContentSlugs} />
      </DefineVariables>
    </div>
  );

CmsOfferUnwrapped.propTypes = {
  cmsContentSlugs: PropTypes.arrayOf(PropTypes.string).isRequired,
  currency: PropTypes.string,
  intl: intlShape.isRequired,
  offer: PropTypes.object,
};

export const mapStateToProps = state => {
  const promoAlias = selectPagePromotion(state);
  const promotion = selectActivePromotion(state, promoAlias);

  const lsOffer = readLocalStorage(LS_OFFER_BANNER_KEY);
  const activeOffer = (promotion.offers || []).find(Boolean);
  const offer = activeOffer || lsOffer || {};

  return {
    currency: deepExtract('msa.currency_code', offer),
    offer,
  };
};

export const CmsOffer = decorateWith(connect(mapStateToProps), injectIntl, withName('CmsOffer'))(CmsOfferUnwrapped);
